import {
  ArrowRight,
  ArrowUp,
  ArrowUpLeft,
  ArrowUpRight,
  Bike,
  Bus,
  Car,
  CornerUpLeft,
  CornerUpRight,
  Flag,
  GitMerge,
  PersonStanding,
  Redo2,
  RotateCcw,
  Split,
  Undo2,
  type LucideIcon,
} from 'lucide-react';
import type { TravelMode } from '../../services/navigation';

const MANEUVER_ICONS: Record<string, LucideIcon> = {
  'turn-left': CornerUpLeft,
  'turn-right': CornerUpRight,
  'turn-slight left': ArrowUpLeft,
  'turn-slight right': ArrowUpRight,
  'turn-sharp left': CornerUpLeft,
  'turn-sharp right': CornerUpRight,
  'uturn-left': Undo2,
  'uturn-right': Redo2,
  'merge-left': GitMerge,
  'merge-right': GitMerge,
  'fork-left': Split,
  'fork-right': Split,
  roundabout: RotateCcw,
  rotary: RotateCcw,
  depart: Car,
  arrive: Flag,
  continue: ArrowUp,
  straight: ArrowUp,
};

export function resolveManeuverIcon(type: string, modifier?: string): LucideIcon {
  const key = modifier ? `${type}-${modifier}` : type;
  if (MANEUVER_ICONS[key]) return MANEUVER_ICONS[key];
  if (MANEUVER_ICONS[type]) return MANEUVER_ICONS[type];
  if (modifier?.includes('left')) return CornerUpLeft;
  if (modifier?.includes('right')) return CornerUpRight;
  if (type === 'roundabout' || type === 'rotary') return RotateCcw;
  return ArrowRight;
}

export function resolveTravelModeIcon(mode: TravelMode): LucideIcon {
  switch (mode) {
    case 'walking':
      return PersonStanding;
    case 'cycling':
      return Bike;
    case 'transit':
      return Bus;
    case 'driving':
    case 'driving-traffic':
    default:
      return Car;
  }
}

type ManeuverIconProps = {
  type: string;
  modifier?: string;
  size?: number;
  className?: string;
  strokeWidth?: number;
};

export function ManeuverIcon({
  type,
  modifier,
  size = 16,
  className,
  strokeWidth = 2,
}: ManeuverIconProps) {
  const Icon = resolveManeuverIcon(type, modifier);
  return <Icon size={size} className={className} strokeWidth={strokeWidth} />;
}

type TravelModeIconProps = {
  mode: TravelMode;
  size?: number;
  className?: string;
  strokeWidth?: number;
};

export function TravelModeIcon({
  mode,
  size = 20,
  className,
  strokeWidth = 2,
}: TravelModeIconProps) {
  const Icon = resolveTravelModeIcon(mode);
  return <Icon size={size} className={className} strokeWidth={strokeWidth} />;
}
